module.exports = __webpack_public_path__ + "media/images/icn-fb-footer-c3696976.png";